import styled from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const StyleClipAddBtnOld = styled.div`
  position: relative;

  .style-clip-add-btn {
    overflow: hidden;
    width: 40px;
    height: 40px;
    border-radius: 100%;
    background: #000;

    svg path {
      fill: #fff;
    }
  }

  .tooltip-item {
    position: absolute;
    top: 5px;
    right: 55px;

    em {
      color: #ff6b33;
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    .style-clip-add-btn {
      width: ${mixin.pxToVw('40')};
      height: ${mixin.pxToVw('40')};

      svg {
        width: ${mixin.pxToVw('14')};
        height: ${mixin.pxToVw('14')};
      }
    }

    .tooltip-item {
      top: ${mixin.pxToVw('5')};
      right: ${mixin.pxToVw('55')};
    }
  }
`;
